import { takeLatest, put, select } from 'redux-saga/effects';
import { PCStoreJsBridge } from '../nativeapi';
import {
  APKS_REQ_INSTALL_LIST_START,
  APKS_REQ_INSTALL_START,
  APKS_REQ_RUN_START,
} from '../constants/anative';
import {
  DOENLOAD_PREPARING,
  DOWNLOAD_FAILED,
} from '../constants/softstatus';
import { addDownload, updateDownloadSoftStatus } from '../actions/download';
import { logNative } from '../utils/utils';

/**
 * 安装多个安卓应用
 * @param {*} param0 
 */
function* fetchInstallAndroidSoftList({ softList }) {
  if (softList.length > 0) {
    for (let i = 0; i < softList.length;  i += 1){
      yield fetchInstallAndroidSoft({ soft: softList[i] });
    }
  }
}

/**
 * 安装单个安卓应用
 * @param {} param0 
 */
function* fetchInstallAndroidSoft({ soft }) {
  try {
    if (!soft.packageName) return ;
    const softStatus = { SoftID: soft.softID, status: DOENLOAD_PREPARING, averagespeed: 0 };
    const softs = yield select(state => state.download.softs);
    const found = softs.find(v => v.softID === soft.softID);
    if (found) {
      if (found.status === DOWNLOAD_FAILED) {
        yield put(addDownload({ ...soft, status: 0 }));
        const ret = yield PCStoreJsBridge.installAndroidSoft(soft);
        if (ret === 'false') {
          softStatus.status = DOWNLOAD_FAILED;
        }
        yield put(updateDownloadSoftStatus(softStatus))
      }
    } else {
      // 先添加一个状态为开始(status: 0 即准备中)的下载任务
      yield put(addDownload({ ...soft, status: 0 }));
      // 再调用客户端下载接口
      const ret = yield PCStoreJsBridge.installAndroidSoft(soft);
      // 调用下载接口失败，更改任务状态
      if (ret === 'false') {
        softStatus.status = DOWNLOAD_FAILED;
      }
      yield put(updateDownloadSoftStatus(softStatus))
    }
  } catch (error) {
    logNative('fetchInstallAndroidSoft 错误', error);
  }
}

function *fetchRunAndroidSoft ({ soft }) {
  try {
    yield PCStoreJsBridge.openAndroidSoft(soft);
  } catch (error) {
    logNative('fetchRunAndroidSoft 错误', error);
  }
}

export function* watchFetchInstallAndroidSoft() {
  yield takeLatest(APKS_REQ_INSTALL_START, fetchInstallAndroidSoft);
}

export function* watchFetchInstallAndroidSoftList() {
  yield takeLatest(APKS_REQ_INSTALL_LIST_START, fetchInstallAndroidSoftList);
}

export function* watchFetchRunAndroidSoft() {
  yield takeLatest(APKS_REQ_RUN_START, fetchRunAndroidSoft);
}
